import ActionTypes from './../common/ActionTypes';
import Strings from './../common/Strings';
import Constant from './../common/Constant';
import { uiActions } from './index';
import { history } from '../helpers';

const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/functions');

const moment = require('moment');

let projectsFetched = false;
let projectsSnapshot;

function setLoading(loading) {
  return {
    type: ActionTypes.PROJECTS_LOADING,
    loading,
  };
}

function setFailed(isFailed) {
  return {
    type: ActionTypes.PROJECTS_FAILED,
    isFailed,
  };
}

function projectCreated(project) {
  return {
    type: ActionTypes.PROJECT_CREATED,
    project,
  };
}

function projectDeleted(project) {
  return {
    type: ActionTypes.PROJECT_DELETED,
    project,
  };
}

function projectUpdated(project) {
  return {
    type: ActionTypes.PROJECT_UPDATED,
    project,
  };
}

function setCreatingOrUpdatingProject(isCreatingOrUpdatingProject) {
  return {
    type: ActionTypes.CREATING_OR_UPDATING_PROJECT,
    isCreatingOrUpdatingProject: isCreatingOrUpdatingProject,
  };
}

function addRemoveMember(email) {
  return {
    type: ActionTypes.ADD_REMOVING_PROJECT_MEMBER,
    email,
  };
}

function removeRemoveMember(email) {
  return {
    type: ActionTypes.REMOVE_REMOVING_PROJECT_MEMBER,
    email,
  };
}

function fetchProjects() {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      projectsFetched = false;
      dispatch(setLoading(true));
      dispatch(setFailed(false));
      stopSync();

      projectsSnapshot = firebase
        .firestore()
        .collection('projects')
        .where('ownerUid', '==', currentUser.uid)
        .onSnapshot(
          snapshot => {
            snapshot.docChanges().forEach(change => {
              const changeType = change.type;
              const project = change.doc.data();
              project.id = change.doc.id;

              if (changeType === 'added') {
                dispatch(projectCreated(project));
              } else if (changeType === 'modified') {
                dispatch(projectUpdated(project));
              } else if (changeType === 'removed') {
                dispatch(projectDeleted(project));
              }
            });

            if (!projectsFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(false));
            }

            projectsFetched = true;
          },
          () => {
            if (!projectsFetched) {
              dispatch(setLoading(false));
              dispatch(setFailed(true));
            }
          },
        );
    }
  };
}

function stopSync() {
  if (projectsSnapshot) {
    projectsSnapshot();
  }
}

function createProject(name, color, currencyCode) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(setCreatingOrUpdatingProject(true));

      const project = {
        ownerUid: currentUser.uid,
        createdAt: moment().format(Constant.DATE_FORMAT_LONG),
        name,
        color,
        currencyCode,
        status: 'active',
        teamMembers: [],
      };

      const ref = firebase
        .firestore()
        .collection('projects')
        .doc();
      ref
        .set(project)
        .then(() => {
          dispatch(setCreatingOrUpdatingProject(false));

          project.id = ref.id;
          history.replace('#invite', { project });
        })
        .catch(() => {
          dispatch(setCreatingOrUpdatingProject(false));
          dispatch(
            uiActions.showError(
              Strings.ERROR.defaultTitle,
              Strings.ERROR.defaultBody,
            ),
          );
        });
    }
  };
}

function updateProject(project) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      dispatch(setCreatingOrUpdatingProject(true));

      const ref = firebase
        .firestore()
        .collection('projects')
        .doc(project.id);
      ref
        .set(project, { merge: true })
        .then(() => {
          dispatch(setCreatingOrUpdatingProject(false));
          history.goBack();
        })
        .catch(() => {
          dispatch(setCreatingOrUpdatingProject(false));
          dispatch(
            uiActions.showError(
              Strings.ERROR.defaultTitle,
              Strings.ERROR.defaultBody,
            ),
          );
        });
    }
  };
}

function removeProjectMember(project, teamMember) {
  return dispatch => {
    const { currentUser } = firebase.auth();

    if (currentUser) {
      const { uid, email } = teamMember;
      dispatch(addRemoveMember(email));

      firebase
        .auth()
        .currentUser.getIdToken()
        .then(idToken => {
          const httpsCallable = firebase
            .functions()
            .httpsCallable('removeProjectMember');
          httpsCallable(
            JSON.stringify({ idToken, projectId: project.id, email, uid }),
          )
            .then(() => {
              dispatch(removeRemoveMember(email));
            })
            .catch(() => {
              dispatch(removeRemoveMember(email));
              dispatch(
                uiActions.showError(
                  Strings.ERROR.errorRemoveProjectMemberTitle,
                  Strings.ERROR.errorRemoveProjectMember,
                ),
              );
            });
        })
        .catch(() => {
          dispatch(removeRemoveMember(email));
          dispatch(
            uiActions.showError(
              Strings.ERROR.errorRemoveProjectMemberTitle,
              Strings.ERROR.errorRemoveProjectMember,
            ),
          );
        });
    }
  };
}

export const projectActions = {
  fetchProjects,
  stopSync,
  createProject,
  updateProject,
  removeProjectMember,
};



// WEBPACK FOOTER //
// ./src/actions/project.js